import FullCalendar from "@fullcalendar/react"
import { MenuItem, Select } from "@mui/material"
import {
	CurrentPageStore,
	NewCalenderPageCount,
	searchByPropertyName,
	selectedProperty,
} from "@store/index"
import { MutableRefObject, SetStateAction, useMemo } from "react"
import { useTranslation } from "react-i18next"
import { IoIosArrowDown } from "react-icons/io"
import { useSetRecoilState } from "recoil"
interface IProps {
	switchView: "dayGridMonth" | "resourceTimelineWeek"
	calendarRef: MutableRefObject<FullCalendar | null>
	setSwitchView: (
		value: SetStateAction<"dayGridMonth" | "resourceTimelineWeek">
	) => void
}
export default function SwitchView({
	switchView,
	calendarRef,
	setSwitchView,
}: IProps) {
	const setCurrentPage = useSetRecoilState(CurrentPageStore) // State to track current page
	const setSelectedProperty = useSetRecoilState(selectedProperty)
	const searchByPropertyNameState = useSetRecoilState(searchByPropertyName)
	const setPageCount = useSetRecoilState(NewCalenderPageCount)
	const { t } = useTranslation()
	const today = new Date()
	const calendarApi = calendarRef.current?.getApi()

	const data = useMemo(() => {
		const list = [
			{
				value: "dayGridMonth",
				label: t("COMMON.MONTHLY"),
			},
			{
				value: "resourceTimelineWeek",
				label: t("COMMON.WEEKLY"),
			},
		]

		return list ?? []
	}, [])
	return (
		<div className='containerCustomSelectOption'>
			<Select
				value={switchView}
				onChange={(event) => {
					setPageCount(1)
					calendarApi?.gotoDate(today) // Navigate to current day
					calendarRef.current?.render()
					setSwitchView(
						event.target.value as "dayGridMonth" | "resourceTimelineWeek"
					)
					setSelectedProperty(undefined)
					searchByPropertyNameState(undefined)
					setCurrentPage(1)
				}}
				IconComponent={IoIosArrowDown}
			>
				{data.map((item, index) => {
					return (
						<MenuItem value={item.value} key={index}>
							{item.label}
						</MenuItem>
					)
				})}
			</Select>
		</div>
	)
}
